import React, { useState, useEffect, useContext } from 'react';  // وارد کردن useContext
import { Tabs } from "antd";
import { fetchArticles } from 'api/articleservice';
import "../css/ActiveTabs.css"; // اضافه کردن فایل CSS سفارشی
import { ArticlesContext } from '../../../contexts/ArticlesContext'

const ArticlesTab = ({tabNames}) => {

  const [activeKey, setActiveKey] = useState("2"); //default:new articles
  const { setArticles, setTotalCount, page, pageSize } = useContext(ArticlesContext);

useEffect(() => {
  let isMounted = true;

  fetchArticles(activeKey, page, pageSize).then((data) => {
    if (isMounted) {
      setArticles(data?.data || []);
      setTotalCount(data?.meta?.total || 0);
    }
  });
  
  return () => { isMounted = false };
}, [activeKey, page, pageSize]);

  const onChange = (key) => {
    setActiveKey(key);
  };



  return (
    <div>
      <Tabs 
        onChange={onChange} 
        type="card" 
        className="custom-tabs" // اضافه کردن کلاس سفارشی
        items={tabNames.map(tab => ({ label: tab.label, key: tab.key }))}
      />
      
      
    </div>
  );
};

export default ArticlesTab;
